import React from 'react';
import moment from 'moment';
import { useStyles } from './styles';
import { StatusSituationType } from 'utils/StatusSituationType';
import {
  MARCADORES_DE_TROCA,
  TROCAS,
  corDaSituacao,
  familiaDaAgenda,
  trocaDaAgenda,
} from 'utils/situacao';

const NOME_DA_TROCA = {
  [TROCAS.ENVIADA]: 'enviado a outro profissional',
  [TROCAS.RECEBIDA]: 'recebido de outro profissional',
};

const SwitchSituation = ({ item, element }) => {
  const classes = useStyles();
  const { situation, situation_status, user_old, user_new } = item;

  const situacao = StatusSituationType(classes, user_old, user_new).find(
    ({ id }) => id === `${situation}${situation_status}`
  );

  const cor = corDaSituacao(familiaDaAgenda(item)).texto;
  const troca = trocaDaAgenda(item);
  const marcadorDeTroca = MARCADORES_DE_TROCA.find(
    (marcador) => marcador.troca === troca
  );

  const ehPassado = () => {
    const today = moment();
    return moment(element?.date_start).diff(today, 'days') < 0;
  };

  const getClassName = () => {
    return element && ehPassado() ? classes.status_opacity : classes.status;
  };

  return (
    <div className={getClassName()} style={{ color: cor }}>
      {marcadorDeTroca && (
        <span
          role="img"
          className={classes.marcadorDeTroca}
          aria-label={NOME_DA_TROCA[troca]}
          title={NOME_DA_TROCA[troca]}
        >
          {marcadorDeTroca.marcador}
        </span>
      )}
      {situacao?.icon}
      {situacao?.label}
    </div>
  );
};

export default SwitchSituation;
